import { useCallback } from 'react'

/**
 * onInteractOutside handler for Dialog/DialogSplit: swallows Radix's default
 * dismiss (and the pointerdown-derived mousedown) and closes via onClose.
 * Originally guarded dialogs inside the since-removed portfolio/components/modal.
 */
export function useDialogInsideTableModal({
  onClose,
  preventClose = false,
}: {
  onClose: () => void
  preventClose?: boolean
}) {
  const onInteractOutside = useCallback(
    (e: Event) => {
      e.preventDefault()

      const originalEvent = (e as CustomEvent<{ originalEvent: PointerEvent }>)
        .detail?.originalEvent
      originalEvent?.preventDefault()

      if (preventClose) return
      onClose()
    },
    [onClose, preventClose],
  )

  return { onInteractOutside }
}
